import { Card, CardContent, Typography } from '@material-ui/core'
import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts'

import { useStyles } from './styles'

const Graphic = ({
  data,
  dataKeyBar,
  colorFill,
  dataKeyLabel,
  dataKeyXAxis,
}) => {
  const classes = useStyles()

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Card className={classes.root}>
          <CardContent>
            <Typography
              color="textPrimary"
              id={`graphicTooltipDate${dataKeyBar}${label}`}
              gutterBottom
            >
              {`Date : ${label}`}
            </Typography>
            <Typography
              variant="body2"
              component="p"
              color="primary"
              id={`graphicTooltipValue${dataKeyBar}${payload[0].payload[dataKeyLabel]}`}
            >
              {`${payload[0].name} :  ${payload[0].payload[dataKeyLabel]}`}
            </Typography>
          </CardContent>
        </Card>
      )
    }

    return null
  }

  return (
    <BarChart
      width={900}
      height={200}
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
      id={`graphicBarChart${dataKeyBar}`}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis
        dataKey={dataKeyXAxis}
        id={`graphicXAxis${dataKeyBar}${dataKeyXAxis}`}
      />
      <YAxis />
      <Tooltip content={<CustomTooltip />} />
      <Legend />
      <Bar
        dataKey={dataKeyBar}
        fill={colorFill}
        id={`graphicBar${dataKeyBar}`}
      />
    </BarChart>
  )
}

export default Graphic
